import React from 'react';
import { Header } from '../components/global/header';
import { ForgotPassword } from '../components/auth/forgotPassword';
import { Footer } from '../components/global/footer';

const ForgotPasswordPage = () => {
  return (
    <div>
      <Header />
      <ForgotPassword />
      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;
